export const isDraftForAccount = (
  draftProfileId: string,
  accountProfileId: string
): boolean => !draftProfileId || draftProfileId === accountProfileId;
